<template>
	<div
		class="modal"
		data-backdrop="static"
		id="editCampaign"
		role="dialog"
		tabindex="-1"
		aria-labelledby="addCampaignGroup"
		aria-hidden="true"
	>
		<div class="modal-dialog modal-xl" role="document">
			<div class="modal-content campaign-g-addedit" style="min-height:350px">
				<div class="modal-header">
					<h5 class="modal-title" id="exampleModalLongTitle">{{addOrEdit ? 'Edit' : 'Add '}} Campaign Group</h5>
					<button type="button" class="close" data-dismiss="modal">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div
					v-show="showSpinner"
					class="spinner-border"
					style="margin:auto;display:block;margin-top:60px"
				></div>
				<div v-show="!showSpinner">
					<div class="modal-body main_form_block">
						<div class="form-container" style="width:1000px; padding-top:10px">
							<form v-on:submit.prevent>
								<div class="form-group row">
									<label class="col-sm-2 col-form-label">
										Client Name
									</label>
									<div
										v-if="isLoadingClient"
										class=" spinner-border"
										style="display:block;"
									></div>
									<div class="col-sm-5" v-else>
										<multiselect
											v-model="clientData"
											:options="clientList"
											label="client_name"
											:searchable="true"
											ref="multiselect"
											track-by="client_name"
											open-direction="bottom"
											class="form-control multi-dropdown select_filter"
											placeholder="Client"
											selectLabel
											deselectLabel
											selectedLabel
											:showLabels="true"
											style="max-height:40px;"
											:multiple="false"
											id="mutiselect"
											@select="clientSelected"
											@remove='clientRemoved'
											:disabled="this.campaignId && this.campaignId!='null'"
										/>
									</div>
								</div>
								<div v-if="showisVendorList && false">
									<CampaignFormDropDown
										ref="multiselectRef"
										:isVendor="showVendor"
										label="Vendor"
										selection="Vendor Selection"
										@showNextView="showBrandFormView"
										isMultiSelect="false"
										:vendorVal="vendor_id"
										:nonEditable="campaignId == 'null' ? false:(campaignId == 'NullWithPrefilledVendorBrand' && $route.name=='campaignList'?false:true) "
										:vendor_name="vendor_name"
										:dataLoading="showVendorLoader"
										:dropdownList="vendorDropDownList"
										:selectedValue="vendor_id"
										:selectedList="[]"
										placeholder="Vendor"
										:getRemoveAlso='true'
									/>
								</div>
								<div v-if="showisBrandsList && renderComponent">
									<CampaignFormDropDown
									    ref="multiselectRef"
										:isBrand="showisBrandsList"
										label="Brand"
										selection="Brand Selection"
										@showNextView="showProductsFormView"
										fromProduct="true"
										isMultiSelect="false"
										:brandVal="brand_id"
										:nonEditable="(campaignId == 'null' ? false:(campaignId == 'NullWithPrefilledVendorBrand' ? false:((brand_id == '' && campaignId != 'null'&& campaignId != 'NullWithPrefilledVendorBrand') ? false:true)))"
										:brand_name="brand_name"
										:dataLoading="showBrandLoader"
										:dropdownList="brandDropDownList"
										:selectedValue="brand_id"
										:selectedList="[]"
										calledFrom = "product"
										placeholder="Brand"
										:getRemoveAlso='true'
									/>
								</div>
								
								<div v-if="showRemainingForm" style="margin-top:38px">
									<div class="form-group">
										<label for="campaignGroupName">Campaign Group Name 	<sup>*</sup></label>
										<div class="row">
											<div class="col-md-10">
												<input
													type="text"
													required="true"
													v-model="Item.name"
													class="form-control"
													id="campaignGroupName"
													v-on:blur="checkDuplicate(Item.name)"
													v-on:click="hideSpan()"
													placeholder="Campaign group name"
												>
											</div>
											<div v-if="this.showLoader" style="padding-left:3px" class="spinner-border"></div>
										</div>
										<span
											v-if="showSpan"
											style="color:red;font-size:13px;"
										>Camapign group already exist with that name</span>
										<span
											v-if="emptyCampGrpNameSpan"
											style="color:red;font-size:13px;"
										>Campaign group name is a mandatory field</span>
									</div>

									<div v-if="campaignId != 'null'" class="form-group">
										<label for="dailyBudget">Current Daily Budget<sup>*</sup></label>
										<div class="row">
											<div class="col-md-10">
												<input
													type="text"
													required="true"
													v-model="Item.daily_budget"
													class="form-control"
													disabled="true"
													id="dailyBudget"
												>
											</div>
										</div>
									</div>
									<div
										v-if="campaignId !='null' && showToggle"
										class="form-group row"
										style="padding-left:0px;margin-top:40px"
									>
										<label style="color:#3da3a7;padding-right:8px">
											<b>Show Expired Budget</b>
										</label>
										<toggle-button v-model="showExpired" value="showExpired"/>
									</div>
									<ModifyEdit
										v-for="(i,index) in Item.budget"
										:key="index + '-' + i.id"
										:arrIndex="index"
										:campaignId="campaignId"
										:budgetItems="Item.budget"
										@add="addToBudget"
										@delete="deleteFromBudget"
										@unhideShowAdd="unhideShowAdd"
										@hideShowAdd="hideShowAdd"
										@showToggleButton="showToggleButton"
										@decreementArrayDates="decreementArrayDates"
										@increementArrayDates="increementArrayDates"
										@getCampaignGroupById="getCampaignGroupById"
										@alterEdit="alterEdit"
										@hideEmptyBudgetSpan="hideEmptyBudgetSpan"
										:singleBudget="i"
										:showAdd="showAdd"
										:confirmDelete="confirmDelete"
										:startDateArray="startDateArray"
										:endDateArray="endDateArray"
										:allowEdit="allowEdit"
										:showExpired="showExpired"
									></ModifyEdit>
									<span
											v-if="emptyBudgetSpan"
											style="color:red;font-size:13px;"
										>All budget fields are mandatory</span>
									<div style="padding:25px;padding-left:6px;text-align: center;">
										<button
											v-on:click="addToBudget()"
											class="btn btn-primary form-group row"
											v-if="Item.budget.length == 0 || (notExpiredStatusArray.length == 0 && !showExpired)"
										>Configure Daily Budget</button>
									</div>
									<div class="form-group">
										<label>Strategy	<sup>*</sup></label>
										<div class="row">
											<div class="col-md-3">
												<div
													id="sales"
													class="strategy"
													@click="Item.strategy = 'Sales'"
													:class="Item.strategy == 'Sales' ? 'sales' : ''"
													v-on:click="hideEmptyStrategySpan"
												>Sales</div>
											</div>
											<div class="col-md-3">
												<div
													id="roi"
													class="strategy"
													@click="Item.strategy = 'ROI'"
													:class="Item.strategy == 'ROI' ? 'roi' : ''"
													v-on:click="hideEmptyStrategySpan"
												>ROI</div>
											</div>
											<div class="col-md-3">
												<div
													id="vCPM"
													class="strategy"
													@click="Item.strategy = 'vCPM'"
													:class="Item.strategy == 'vCPM' ? 'vcpm' : ''"
													v-on:click="hideEmptyStrategySpan"
												>vCPM</div>
											</div>
										</div>
										<span
											v-if="emptyStrategySpan  && !Item.strategy"
											style="color:red;font-size:13px;"
										>Select a strategy to proceed</span>
									</div>
									<div
										class="form-group"
										id="add_constraints"
										v-if="Item.strategy == 'ROI'"
									>
										<label>Constraint: Minimum Spend</label>
										<select
											id="add_lb_spend"
											v-on:click="hideEmptyStrategySpan"
											v-model="roiSpend"
											class="form-control col-md-10"
										>
											<option value>--- Select ---</option>
											<option value="10">10% of Budget</option>
											<option value="25">25% of Budget</option>
											<option value="20">20% of Budget</option>
											<option value="30">30% of Budget</option>
											<option value="40">40% of Budget</option>
											<option value="50">50% of Budget</option>
											<option value="60">60% of Budget</option>
											<option value="70">70% of Budget</option>
											<option value="75">75% of Budget</option>
											<option value="80">80% of Budget</option>
											<option value="90">90% of Budget</option>
											<option value="100">100% of Budget</option>
										</select>
									</div>
									<span
										v-if="emptyStrategySpan && Item.strategy == 'ROI' "
										style="color:red;font-size:13px;"
									>Select minimum spend to proceed</span>
									<div
										class="form-group"
										id="add_constraints"
										v-if="Item.strategy == 'vCPM'"
									>
										<label>Constraint: Minimum Spend</label>
										<select
											id="add_lb_spend"
											v-on:click="hideEmptyStrategySpan"
											v-model="vCPMSpend"
											class="form-control col-md-10"
										>
											<option value>--- Select ---</option>
											<option value="10">10% of Budget</option>
											<option value="25">25% of Budget</option>
											<option value="20">20% of Budget</option>
											<option value="30">30% of Budget</option>
											<option value="40">40% of Budget</option>
											<option value="50">50% of Budget</option>
											<option value="60">60% of Budget</option>
											<option value="70">70% of Budget</option>
											<option value="75">75% of Budget</option>
											<option value="80">80% of Budget</option>
											<option value="90">90% of Budget</option>
											<option value="100">100% of Budget</option>
										</select>
									</div>
									<span
										v-if="emptyStrategySpan && Item.strategy == 'vCPM' "
										style="color:red;font-size:13px;"
									>Select minimum spend to proceed</span>
								</div>
							</form>
						</div>
						<div v-if="showRemainingForm" class="modal-footer">
							<button type="button" class="btn btn-secondary" v-on:click="cancel">Cancel</button>
							<button
								class="btn btn-primary"
								v-on:click="submit"
								id="submit"
							>Save </button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- <DeletePopUp
      v-if="isOpenDeleteModal"
      @deleteData="deleteData"
      @hideDeleteModal="hideDeleteModal"
		/>-->
	</div>
</template>

<script>
	import moment from "moment";
	import ModifyEdit from "@/components/campaign-group/ModifyEdit";
	import DeletePopUp from "../delete/DeletePopUp.vue";
	import CampaignFormDropDown from "@/components/add-campaign/CampaignFormDropDownNew";
	import ClientData from "@/components/account-management/ClientData.vue";
	import Multiselect from "vue-multiselect";
	var numeral = require("numeral");
	const formatCurrency = require("format-currency");
	export default {
		name: "EditCampaignGroupModal",
		components: {
			ModifyEdit,
			DeletePopUp,
			CampaignFormDropDown,
			ClientData,
			Multiselect
		},
		props: ["campaignId", "campaignVendor_id", "campaignBrand_id","calledFrom"],
		data() {
			return {
				roiSpend: "",
				vCPMSpend:"",
				notExpiredStatusArray: [],
				emptyCampGrpNameSpan:false,
				showisVendorList: false,
				emptyStrategySpan: false,
				showToggle: false,
				vendor_name: "",
				brand_name: "",
				showRemainingForm: false,
				vendor_id: "",
				brand_id: "",
				showisBrandsList: false,
				showVendor: true,
				showSpinner: false,
				input: [],
				configureDailyFlag: false,
				showExpired: false,
				selected: "",
				showAdd: false,
				allowEdit: true,
				confirmDelete: false,
				startDateArray: [],
				endDateArray: [],
				emptyBudgetSpan:false,
				Item: {
					id: "",
					name: "",
					daily_budget: "0",
					requestType: "",
					strategy: "",
					budget: [],
					itemToDelId: {}
				},
				showLoader: false,
				showSpan: false,
				originalName: "",
				showVendorLoader: false,
				showBrandLoader: false,
				showProductLoader: false,
				vendorDropDownList: [],
				brandDropDownList: [],
				productDropDownList: [],
				renderComponent: true,
				isLoadingClient: false,
				clientList:[],
				clientData:null
			};
		},
		computed: {
			addOrEdit: {
				get() {
					return (this.campaignId != "null" && this.campaignId != "NullWithPrefilledVendorBrand");
				}
			}
		},
		watch: {},
		methods: {
			// saveCampaignGroupfromCampaign(){
			// 	if(this.$store.state.campaign.campaignToAddToGroupList.length > 0)
			// 	return true;
			// 	else
			// 	return false;
			// },
			clientSelected(data){
				this.brand_id = null
				this.forceRerender()
				this.clientData = data
				if(data){
					this.initiateNewCg()
				}
			},
			clientRemoved(){
				this.brand_id = null
				this.forceRerender()
				this.clientData = null
				this.showBrandFormView()
			},
			getClientList() {
				this.isLoadingClient = true;
				const vm = this;
				this.$store.dispatch("getAccountClient").then((res) => {
					vm.clientList = res.filter((e) => e.client_name);
					vm.isLoadingClient = false;
					vm.setCampaignGroup()
				});
			},
			computeStatus() {
				this.notExpiredStatusArray = [];
				this.Item.daily_budget = 0;
				for (var i = 0; i < this.Item.budget.length; i++) {
					var status = moment()
						.subtract(1, "days")
						.isAfter(moment(this.Item.budget[i].end_date))
						? "Expired"
						: moment().isAfter(moment(this.Item.budget[i].start_date))
						? "Active"
						: "Pending";
					this.Item.budget[i].status = status;
					if (
						status == "Active" ||
						status == "notSet" ||
						status == "Pending"
					) {
						this.notExpiredStatusArray.push(status);
					}
					if (status == "Active") {
						this.Item.daily_budget = this.formatDailyBudget(
							this.Item.budget[i].budget
						);
					}
					if(status == "Expired"){
						this.showToggle = true;
					}

				}
			},
			formatDailyBudget(num) {
				var num = formatCurrency(num);
				return num;
			},
			showVendorList(data, callback) {
				this.showisBrandsList = false;
				this.showisProductList = false;
				this.showRemainingForm = false;
				this.fetchVendorList(callback);
			},
			fetchVendorList(callback) {
				const vm = this;
				this.showVendorLoader = true;
				
				vm.showVendorLoader = false;
				vm.showisVendorList = true;
				callback ? callback.call(vm, []) : "";
				return
				if(this.clientData){
					// this.$store.dispatch("accounts/getVendorByClient",{client_id:this.clientData.client_id}).then(res => {
					// 	vm.showVendorLoader = false;
					// 	vm.showisVendorList = true;
					// 	callback ? callback.call(vm, res) : "";
					// });
					vm.showVendorLoader = false;
					vm.showisVendorList = true;
					callback ? callback.call(vm, []) : "";
				}
				else{
					this.$store.dispatch("getAllVendor").then(res => {
						vm.showVendorLoader = false;
						vm.showisVendorList = true;
						callback ? callback.call(vm, res) : "";
					});
				}
				
			},
			forceRerender () {
				this.renderComponent = false;
				this.$nextTick (() => {
				 this.renderComponent = true;
				});
			},
			showBrandFormView(data, callback) {
				if (this.campaignId == "null" && !this.clientData) {
					this.brand_id = "";
					this.forceRerender()
				}
				if (data != 0 && data!=null) {
					this.showisProductList = false;
					this.showRemainingForm = false;
					this.showisBrandsList = true;
					this.vendor_id = data && data.id || data;
					this.fetchBrandList((data && data.id || data) , callback);
				}
				else if((this.clientData)){
					this.showisProductList = false;
					this.showRemainingForm = false;
					this.showisBrandsList = true;
					this.fetchBrandList((data && data.id || data) , callback,'client');
				}
				else if(this.brand_id){
					this.showisProductList = false;
					this.showRemainingForm = false;
					this.showisBrandsList = true;
					this.fetchBrandList((data && data.id || data) , callback);
				}
				else {
					this.showisBrandsList = false;
					this.showRemainingForm = false;
				}
			},
			fetchBrandList(vendorId, callback,type) {
				const vm = this;
				this.showBrandLoader = true;
				if(this.clientData && type=='client'){
					let pay = {
						'go_client_id':this.clientData.client_id
					}
					this.$store.dispatch("campaign/fetchBrandByClient", pay).then(res => {
						vm.showBrandLoader = false;
						vm.brandDropDownList = res;
						if(vm.brand_id){
							vm.$refs["multiselectRef"].populateBrand(res, vm.brand_id)
						}
						callback ? callback.call(vm, res) : "";
					});
				}
				else{
					this.$store.dispatch("getAllBrandProfile", {}).then(res => {
						vm.showBrandLoader = false;
						vm.brandDropDownList = res;
						if(vm.brand_id){
							vm.setClientFromBrand(vm.brand_id)
							vm.$refs["multiselectRef"].populateBrand(res, vm.brand_id)
						}
						callback ? callback.call(vm, res) : "";
					});
				}
			},
			showProductsFormView(data, callback) {
				if (data != 0 && data!=null) {
					this.brand_id = data && data.id || data;
					this.showRemainingForm = true;
				} else {
					if(!data){
						this.brand_id = null
					}
					this.showRemainingForm = false;
				}
			},
			showToggleButton(data) {
				this.showToggle = data;
				if (data == false) {
					this.showExpired = false;
				}
			},
			checkDuplicate(campaignName) {
				if (
					this.Item.name &&
					(this.Item.name != this.originalName && this.campaignId)
				) {
					this.showLoader = true;
					var body = { name: campaignName };
					this.$store
						.dispatch("campaign/checkDuplicacyByName", body)
						.then(res => {
							if (res.total != 0) {
								//this.Item.name = "";
								this.showSpan = true;
								// $("#addCampaignGroupName").attr(
								//   "placeholder",
								//   "Camapign Already Exist With That Name"
								// );
							} else {
								this.showSpan = false;
							}
							this.showLoader = false;
						});
				}
			},
			hideSpan() {
				this.showSpan = false;
				this.emptyCampGrpNameSpan = false;
			},
			arrayOfDate() {
				(this.startDateArray = []), (this.endDateArray = []);
				for (var i = 0; i < this.Item.budget.length; i++) {
					this.startDateArray.push(this.Item.budget[i].start_date);
					this.endDateArray.push(this.Item.budget[i].end_date);
				}
			},
			increementArrayDates(index) {
				// this.startDateArray.push(this.Item.budget[index].start_date);
				// this.endDateArray.push(this.Item.budget[index].end_date);
				this.arrayOfDate();
			},
			decreementArrayDates(index) {
				this.startDateArray.splice(index, 1);
				this.endDateArray.splice(index, 1);
			},
			addToBudget() {
				var budget = {
					budget: "",
					end_date: "",
					start_date: "",
					fallbackBudget: "0",
					status: "notSet"
				};
				this.Item.budget.push(budget);
				this.computeStatus();
			},
			deleteFromBudget(indexDel) {
				this.Item.budget.splice(indexDel, 1);
				this.computeStatus();
			},
			unhideShowAdd() {
				this.showAdd = true;
			},
			hideShowAdd() {
				this.showAdd = false;
			},
			alterEdit() {
				this.allowEdit = !this.allowEdit;
			},
			cancel(){
				if(this.calledFrom=='campaignGroup'){
					this.$store.state.campaign.actionSelectioncampaignGroupControl = false
					this.$store.state.campaign.campaignGroupSelectedList = []
					this.$store
						.dispatch("campaign/getCampaignGroupList")
						.then(res => {
					});
				}
				$('#editCampaign').modal('hide');
				this.$emit('toggleEditCampaignGroupModal')
			},
			hideEmptyStrategySpan(){
				// if (this.Item.strategy == "Sales") {
				// 	this.roiSpend = "";
				// }
				this.emptyStrategySpan = false;
			},
			hideEmptyBudgetSpan(){
				this.emptyBudgetSpan = false;
			},
			submit() {
				if(this.Item.name ==''){
					this.emptyCampGrpNameSpan = true;
				}
				else if(this.showSpan){
					//
				}
				else if(this.Item.strategy ==''){
					this.emptyStrategySpan = true;
				}
				 else if (this.Item.strategy == "ROI" && !this.roiSpend) {
					this.emptyStrategySpan = true;
				}
				else if(this.Item.strategy=="vCPM" && !this.vCPMSpend){
					this.emptyStrategySpan = true;
				}
				else if((this.campaignId == "null" || this.campaignId == "NullWithPrefilledVendorBrand") && (this.Item.budget[0].budget=='' || this.Item.budget[0].start_date==''|| this.Item.budget[0].end_date=='')){
						this.emptyBudgetSpan = true
				}
				else{
				if(this.campaignId == 'NullWithPrefilledVendorBrand'){
					this.showSpinner = true;
				}
				else{
					$('#editCampaign').modal('hide');
					this.$store.commit("showLoadingSpinner", null, { root: true });
				}
				if(this.Item.strategy != "ROI"){
						this.roiSpend = null;
					}
				if(this.Item.strategy!="vCPM"){
					this.vCPMSpend = null;
				}
				if (this.campaignId == "null" || this.campaignId == "NullWithPrefilledVendorBrand") {
					//	var addingFromCampaign = this.saveCampaignGroupfromCampaign();
					var num = numeral(this.Item.budget[0].budget);
					var out = {
						requestType: "saveFirst",
						//addingFromCampaign:addingFromCampaign,
						name: this.Item.name,
						budget: {
							budget: num.value(),
							start_date: this.Item.budget[0].start_date,
							end_date: this.Item.budget[0].end_date,
							fallbackBudget: "0",
							start_date_utc:moment(this.Item.budget[0].start_date).utc().subtract(moment().parseZone().utcOffset(), 'minutes').utc().valueOf(),
							end_date_utc:moment(this.Item.budget[0].end_date).utc().subtract(moment().parseZone().utcOffset(), 'minutes').utc().valueOf(),
						},
						strategy: this.Item.strategy,
						lb_spend: this.roiSpend ? this.roiSpend : this.vCPMSpend ? this.vCPMSpend : null,
						vendor_id: null,
						// this.vendor_id,
						brand_id: this.brand_id
					};
				} else {
					var daily = numeral(this.Item.daily_budget);
					var out = {
						id: this.Item.id,
						requestType: "submit",
						name: this.Item.name,
						daily_budget: daily.value(),
						strategy: this.Item.strategy,
						lb_spend: this.roiSpend ? this.roiSpend : this.vCPMSpend ? this.vCPMSpend : null,
					};
				}
				let vm = this;
				vm.$store
					.dispatch("campaign/editCampaignFromCampaignGroup", out)
					.then(res => {
						if(vm.campaignId == 'NullWithPrefilledVendorBrand'){
							vm.showSpinner = false;
							$('#editCampaign').modal('hide');
							this.$emit("updateCampaignGroupList",res);
						}
						else{
							this.$store.state.campaign.actionSelectioncampaignGroupControl = false
      						this.$store.state.campaign.campaignGroupSelectedList = []
							vm.$store
								.dispatch("campaign/getCampaignGroupList")
								.then(res => {
							});
						}
					});
				}
			},
			sales() {
				this.selected = "Sales";
				this.Item.strategy = this.selected;
			},
			roi() {
				this.selected = "ROI";
				this.Item.strategy = this.selected;
			},
			vCPM(){
				this.selected = "vCPM";
				this.Item.strategy = this.selected
			},
			getCampaignGroupById(onlyBudgetUpdate, callback) {
				var vm = this;
				var id = { id: vm.campaignId };
				console.log(vm.campaignId + "edit");
				this.$store
					.dispatch("campaign/getCampaignGroupById", id)
					.then(response => {
						vm.input = response;
						vm.allExpiredBudgets = [];
						if (!onlyBudgetUpdate) {
							vm.Item.name = vm.input[0].name;
							vm.Item.daily_budget = vm.input[0].daily_budget;
							vm.Item.strategy = vm.input[0].objective;
							vm.roiSpend = vm.input[0].lb_spend && vm.input[0].objective=='ROI' ? vm.input[0].lb_spend : "";
							vm.vCPMSpend = vm.input[0].lb_spend && vm.input[0].objective=='vCPM' ? vm.input[0].lb_spend : "";
							vm.vendor_id = vm.input[0].go_vendor_cd;
							vm.brand_id = vm.input[0].profile_id;
							vm.vendor_name = vm.input[0].vendor_name;
							vm.brand_name = vm.input[0].profile_brand_name;
							vm.showRemainingForm = true;
							vm.showVendorList(null, res => {
								vm.vendorDropDownList = res;
								vm.showisVendorList = true;
								vm.showBrandFormView(vm.vendor_id, () => {
									vm.showProductsFormView(vm.brand_id);
									setTimeout(() => {
										vm.showSpinner = false;
									}, 0);
								});
							});
						}
						vm.Item.id = vm.input[0].id;

						vm.Item.budget = [];
						if (vm.input[0].hasOwnProperty("budget")) {
							for (var i = 0; i < vm.input[0].budget.length; i++) {
								vm.Item.budget.push(vm.input[0].budget[i]);
								vm.computeStatus();
							}
						}
						vm.arrayOfDate();
						vm.confirmDelete = false;
						vm.originalName = vm.Item.name;
						if (callback) {
							callback();
						}
					});
			},
			initiateNewCg(){
				this.showisVendorList = true;
				if(!this.Item.budget.length){
					this.addToBudget();
				}
				const vm = this;
				vm.showVendorList(null, res => {
					vm.vendorDropDownList = res;
					vm.$store.commit("hideLoadingSpinner", null, {
						root: true
					});
					if(vm.clientData){
						vm.showBrandFormView()
					}
					if (vm.$route.params.products) {
						vm.productList = vm.$route.params.products.split("+");
					}
				});
			},
			setClientFromBrand(brandId){
				if(brandId && this.brandDropDownList && this.clientList){
					var brand = this.brandDropDownList.filter(item=>item.id==brandId)
					if(brand && brand.length && brand[0].go_client_id){
						var client = this.clientList.filter(client=>client.client_id==brand[0].go_client_id)
						if(client && client.length){
							this.clientData = client[0]
						}
					}
				}
				if(this.clientData && this.campaignId == "NullWithPrefilledVendorBrand"){
					let pay = {
						'go_client_id':this.clientData.client_id
					}
					const vm = this
					this.showBrandLoader = true
					this.$store.dispatch("campaign/fetchBrandByClient", pay).then(res => {
						vm.showBrandLoader = false;
						vm.brandDropDownList = res;
					});
				}
			},
			setCampaignGroup(){
				if (
					this.campaignId != "null" &&
					this.campaignId != "NullWithPrefilledVendorBrand"
				) {
					this.showSpinner = true;
					this.getCampaignGroupById();
				} else {
					if (this.campaignId == "NullWithPrefilledVendorBrand") {
						this.vendor_id = this.campaignVendor_id;
						this.brand_id = this.campaignBrand_id;
						const vm = this;
						vm.showVendorList(null, res => {
							vm.vendorDropDownList = res;
							vm.showBrandFormView(vm.vendor_id,() =>{
								vm.showProductsFormView(vm.brand_id);
									setTimeout(() => {
									vm.showSpinner = false;
								}, 0);
							});
							vm.showisVendorList = true;
						});
						vm.addToBudget();
					}
				}
			}
		},
		mounted() {
			this.getClientList();
		}
	};
</script>

<style lang="scss">
.campaign-g-addedit {
	.strategy {
		border: 1px solid #e3e3e3 !important;
		border-radius: 4px !important;
		min-height: 90px !important;
		padding: 25px !important;
		text-align: center !important;
		font-size: 20px !important;
		cursor: pointer !important;
	}
}
.campaign-g-addedit {
	.sales {
		border: 1px solid #aed2ca;
		background-color: #effffc;
		box-shadow: 0 15px 44px -20px rgba(1, 168, 131, 0.5);
	}
}
.campaign-g-addedit {
	.roi {
		border: 1px solid #bc97dc;
		background-color: #f6ebff;
		box-shadow: 0 15px 44px -20px rgba(147, 108, 180, 0.5);
	}
}
.campaign-g-addedit {
	.vcpm {
		border: 1px solid #c8cce9;
		background-color: #c8cce9;
		box-shadow: 0 15px 44px -20px #c8cce9;
	}
}
</style>
